export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.9400dbd2.woff";